import useSWR from "swr";
import actionsService from "../../services/actions.service";

const useActionImages = (actionId?: string | number) => {
    const { data, error, isLoading } = useSWR(
        `actions/${actionId}/images`,
        actionId ? () => actionsService.getActionImages(actionId) : null,
        {
            revalidateOnFocus: false,
            revalidateOnReconnect: false,
            refreshWhenHidden: false,
            refreshWhenOffline: false,
            revalidateIfStale: false,
        }
    );

    return {
        images: data?.data || [],
        isLoading: isLoading || !data,
        error,
    };
};

export default useActionImages;
